<script>
import TwButton from '@/components/generic/tw-button.vue'

export default {
  name: 'TwUploadedImage',
  components: { TwButton },
  props: {
    upload: {
      type: Object,
      required: true
    },
    loadingDeleting: {
      type: Boolean,
      default: false
    },
    deleteable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete']
}
</script>

<template>
  <div>
      <!-- Content goes here -->
    <a target="_blank" :href="upload.url"><img :src="upload.url" class="w-auto max-h-20 mt-1"></a>
    <div v-if="deleteable" class="px-4 py-4 sm:px-6 mt-2 flex justify-center">
      <!-- Content goes here -->
      <!-- We use less vertical padding on card footers at all sizes than on headers or body sections -->
      <tw-button variant="secondary" icon="trash" :loading="loadingDeleting" size="sm" @click="$emit('delete', upload)" />
    </div>
  </div>
</template>

<style scoped>

</style>
